import { ResponseError } from '~/utils';
import request from '../request';

export const getProducts = async (): Promise<CreditProductsResponse[]> => {
  try {
    const { data } = await request.get(
      '/credit-services/holders/me/credit/products',
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const getProductsDetails = async (
  id: string,
): Promise<CreditProductsDetails> => {
  try {
    const { data } = await request.get(
      `/credit-services/holders/me/credit/products/${id}`,
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const getSimulationPlans = async (
  amount: number,
  id: string,
): Promise<SimulationPlansResponse> => {
  try {
    const { data } = await request.post(
      `/credit-services/holders/me/credit/products/${id}/simulation`,
      { amount },
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const creditSimulation = async (
  payload: CreditSimulationRequest,
  id: string,
): Promise<SimulationPlansResponse> => {
  try {
    const { data } = await request.post(
      `/credit-services/holders/me/credit/products/${id}/contracts`,
      payload,
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const cancelCreditSimulation = async (): Promise<void> => {
  try {
    await request.post(
      `credit-services/holders/me/credit/products/contracts/cancel`,
    );
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const getPendingWithdraw = async (): Promise<Withdrawal> => {
  try {
    const { data } = await request.get(
      `/credit-services/holders/me/credit/products/contracts/withdrawals/pending`,
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const confirmWithdrawal = async (preAuthorizationId?: string) => {
  try {
    const { data } = await request.post(
      `/credit-services/holders/me/credit/products/contracts/withdrawals/authorize`,
      { preAuthorizationId },
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const generateQRCode = async (document: string): Promise<any> => {
  try {
    const { data } = await request.post('/credit-services/flows/loans/qrcode', {
      document,
    });
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const creditProductsImageValidation = async (
  payload: ImageValidationPayload,
  id: string,
): Promise<void> => {
  try {
    const { data } = await request.post(
      `/credit-services/holders/me/credit/products/${id}/documents`,
      payload,
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const getBanks = async (): Promise<Banks[]> => {
  try {
    const { data } = await request.get(`/credit-services/banks`);
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};
